import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Painel',
  tabs: {
    [tabs.general]: 'Geral',
    [tabs.overview]: 'Visão geral',
    [tabs.orders]: 'Encomendas por origem',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Clientes',
    [tabs.order_conversion]: 'Conversão de encomendas',
    [tabs.mobile_app]: 'App móvel',
  },
  date_range: {
    this_month: 'Este Mês',
    last_month: 'Mês Passado',
    last_week: 'Semana Passada',
    this_week: 'Esta Semana',
    this_year: 'Este Ano',
    last_year: 'Ano Passado',
    today: 'Hoje',
    yesterday: 'Ontem',
    all: 'Todos',
  },
  buttons: {
    view_key_info: 'Ver informações chave',
  },
  empty_franchise: {
    description:
      'Esta marca ainda não tem nenhum restaurante. Escolha outra marca no menu para ver os respetivos números.',
  },
};
